import React, { useEffect, useState } from "react";
import "./landing-page.css";
import car from "../../static/images/car.png";
import car2 from "../../static/images/car2.png";
import dave from "../../static/images/dave-group.png";
import bgImage from "../../static/images/landing-bg.png";
import portfolioDirectory from "../../static/images/portfolio_directory.png";
import portfolioBuilder from "../../static/images/portfolio_builder.png";
import dealers from "../../static/images/dealers.png";
import groups from "../../static/images/groups.png";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { APP_PREFIX_PATH } from "../../Config/AppConfig";
import axiosInstance from "../../service/AxiosInstance";
import InstantReportModal from "./InstantReportModal";
import { useDrawer } from "../layout-components/menu/menuContext";
import { message } from "antd";
import { PortfolioNotification } from "../navbar/PortfolioNotification";
import { getGADashboardUrl } from "../../utils/gaConfig";
// import AIAnalyticsModal from "./AIAnalyticsModal";
import WhiteLogo from "../../static/images/Jump_White.png";
import ReleaseNotesModal from "./ReleaseNotesModal";
import { fetchPreviousFeedbacks } from "../../screens/portfolioApp/portfolio/commonApis";

import moment from "moment";
const LandingPage = () => {
  const { dispatch, state } = useDrawer();

  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [dealerData, setDealerData] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDealerId, setSelectedDealerId] = useState(null);
  const [newValuationName, setNewValuationName] = useState(
    "Estimate" + "_" + moment().format("DD MMM YYYY HH:mm")
  );
  const [warning, setWarning] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState();
  const [isReleaseNotesModalOpen, setIsReleaseNotesModalOpen] = useState(false);
  const [releaseNotesData, setReleaseNotesData] = useState(null);
  const [releaseNotesLoading, setReleaseNotesLoading] = useState(false);
  const [isSuperuser, setIsSuperuser] = useState(false);
  // const [isAIModalOpen, setIsAIModalOpen] = useState(false);

  // useEffect(() => {
  //   // Load Google Analytics gtag.js script
  //   const script1 = document.createElement('script');
  //   script1.async = true;
  //   script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-BCWZ9GPGG1';
  //   document.head.appendChild(script1);

  //   // Initialize gtag function and configure GA
  //   const script2 = document.createElement('script');
  //   script2.innerHTML = `
  //     window.dataLayer = window.dataLayer || [];
  //     function gtag(){dataLayer.push(arguments);}
  //     gtag('js', new Date());
  //     gtag('config', 'G-BCWZ9GPGG1');
  //   `;
  //   document.head.appendChild(script2);

  //   // Cleanup function to remove scripts when component unmounts
  //   return () => {
  //     document.head.removeChild(script1);
  //     document.head.removeChild(script2);
  //   };
  // }, []);

  // Google Analytics is now handled globally in App.js via GoogleAnalyticsTracker

  // Function to fetch previous feedbacks and store in global context
  const loadPreviousFeedbacks = async () => {
    try {
      dispatch({ type: "SET_LOADING_FEEDBACKS", value: true });
      
      const feedbacks = await fetchPreviousFeedbacks();
      dispatch({ 
        type: "SET_PREVIOUS_FEEDBACKS", 
        value: feedbacks 
      });
    } catch (error) {
      console.error("Error fetching previous feedbacks:", error);
      dispatch({ type: "SET_PREVIOUS_FEEDBACKS", value: [] });
    } finally {
      dispatch({ type: "SET_LOADING_FEEDBACKS", value: false });
    }
  };

  // Function to fetch release notes
  const fetchReleaseNotes = async () => {
    try {
      const response = await axiosInstance.get('/fetch_release_notes');
      
      // Store the release notes data in sessionStorage for global access
      if (response.data) {
        sessionStorage.setItem('release_notes_content', JSON.stringify(response.data));
      }
    } catch (error) {
      console.error("Error fetching release notes:", error);
      console.error("Error details:", error.response?.data || error.message);
    }
  };

    useEffect(() => {
    // Check if release notes modal should be shown based on stored data
    checkReleaseNotesModal();
    
    // Check if user is superuser for Google Analytics button visibility
    // In production: only superuser can access GA
    // In dev/staging: all users can access GA
    const currentUrl = window.location.href;
    const isProduction = currentUrl.includes("pro") || currentUrl.includes("valueinsightpro.jumpiq.com");
    const superuserStatus = sessionStorage.getItem('is_superuser');
    
    // If production, check superuser status; otherwise, allow all users
    setIsSuperuser(isProduction ? superuserStatus === 'true' : true);
  }, []);
  console.log(isSuperuser, "isSuperuser");
  

  const checkReleaseNotesModal = () => {
    try {
      // Get release notes data from sessionStorage (set during login)
      const storedData = sessionStorage.getItem("release_notes_data");
      
      if (storedData) {
        const releaseNotesData = JSON.parse(storedData);
        setReleaseNotesData(releaseNotesData);
        
        // Show release notes modal only if show_modal is true in the stored data
        if (releaseNotesData && releaseNotesData.show_modal === true) {
          setIsReleaseNotesModalOpen(true);
        } else {
          console.log('show_modal is false or not present, keeping modal closed');
        }
      } else {
        console.log('No release notes data found in sessionStorage');
      }
    } catch (error) {
      console.error('Error parsing release notes data from sessionStorage:', error);
    }
  };



  useEffect(() => {
    // Clear valuation and portfolio details from navbar when landing page mounts
    dispatch({ type: "SET_VALUATION_NAME", value: "" });
    dispatch({ type: "SET_PORTFOLIO_NAME", value: "" });
    dispatch({ type: "VALUATION_CONFIG", value: "" });
    dispatch({ type: "SET_STEP", value: 0 });
    
    const dealerInfo = JSON.parse(sessionStorage.getItem("dealer_name"));

    if (dealerInfo) {
      setDealerData(dealerInfo.dealerships);
    } else {
      FetchedDealerInfo();
    }
  }, []);

  const FetchedDealerInfo = async () => {
    try {
      const { data: response } = await axiosInstance.get(
        `/get_dealership_suggestions?version=V2`,
        {
          params: {
            username: sessionStorage.getItem("user_name"),
          },
        }
      );
      response.dealerships.forEach((item) => {
        item["dealer__info"] =
          item.dealer__name + " " + item.state__name + " " + item.brand__name;
      });
      setDealerData(response.dealerships);
      setShowOverlay(response.showOverlay);
      sessionStorage.setItem("dealer_name", JSON.stringify(response));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
    setSelectedDealerId(null);
    setNewValuationName(
      "Estimate" + "_" + moment().format("DD MMM YYYY HH:mm")
    );
    const dealerInfo = JSON.parse(sessionStorage.getItem("dealer_name"));
    if (!dealerData && !dealerInfo) {
      FetchedDealerInfo();
    } else if (dealerInfo) {
      setDealerData(dealerInfo.dealerships);
      setLoading(false);
    }
    // !dealerData && FetchedDealerInfo();
  };

  // const showAIModal = () => {
  //   const username = sessionStorage.getItem("user_name");
  //   if (username && username === "mohit") {
  //     setIsAIModalOpen(true);
  //   } else {
  //     warningModal();
  //   }
  // };

  const openAIAnalytics = () => {
    const hasReportAccess = sessionStorage.getItem("has_report_access");
    if (hasReportAccess === "true") {
      navigate(`/${APP_PREFIX_PATH}/ai-analytics`);
    } else {
      warningModal();
    }
  };

  // Google Analytics redirect handler
  const handleGoogleAnalyticsRedirect = () => {
    // Get environment-specific GA dashboard URL
    // If user is already logged into Google, it will open directly
    // Otherwise, it will show Google login page
    const gaUrl = getGADashboardUrl();
    
    // Open Google Analytics in new tab
    window.open(gaUrl, '_blank', 'noopener,noreferrer');
  };

  const handleOk = (valuationId) => {
    // Handle success and navigate
    setIsModalOpen(false);
    navigate(`/JumpFive/Valuations/ValuationEdit/${valuationId}`);
    const saveForm = {
      status: false,
      step: 1,
      prevStep: 0,
    };
    // To navigate to Radius page
    dispatch({ type: "UPDATE_PAYLOAD_DB", value: saveForm });
    dispatch({ type: "SET_STEP", value: 1 });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedDealerId(null);
    setNewValuationName("");
    setWarning(false);
  };

  const warningModal = () => {
    messageApi.open({
      type: "warning",
      content: "This feature is under development",
    });
  };

  const handleReleaseNotesClose = () => {
    setIsReleaseNotesModalOpen(false);
    // Clear the release notes data so modal doesn't show again
    sessionStorage.removeItem("release_notes_data");
  };

  const handleReleaseNotesNext = async () => {
    setReleaseNotesLoading(true);
    
    try {
      if (releaseNotesData ) {

        const payload = {
          changelog_id: releaseNotesData.latest_changelog_id
          // changelog_id: 1
        };
        
        const response = await axiosInstance.post('/release_notes', payload);

        // Close the modal after successful POST
        setIsReleaseNotesModalOpen(false);
        // Clear the release notes data so modal doesn't show again
        sessionStorage.removeItem("release_notes_data");
      } else {
        console.error('No changelog_id available to post');
        setIsReleaseNotesModalOpen(false);
        // Clear the release notes data so modal doesn't show again
        sessionStorage.removeItem("release_notes_data");
      }
    } catch (error) {
      console.error('Error posting release notes:', error);
      console.error('Error details:', error.response?.data || error.message);
      // Still close the modal even if there's an error
      setIsReleaseNotesModalOpen(false);
      // Clear the release notes data so modal doesn't show again
      sessionStorage.removeItem("release_notes_data");
    } finally {
      setReleaseNotesLoading(false);
    }
  };
  return (
    <>
      <PortfolioNotification />
      <div id="landing-page">
        {contextHolder}

        <div className="bg_image">
          <img src={bgImage} alt="Bg-Image" loading="lazy" />
          <div className="choose_destination_text">
            Choose your destination.
          </div>
          
          {/* Google Analytics Button - Top Right (Superuser Only in Production) */}
          {isSuperuser && (
            <button 
              onClick={handleGoogleAnalyticsRedirect}
              className="ga-button"
              title="Open Google Analytics"
            >
              📊 Analytics
            </button>
          )}
          
          {/* Data Updated Label - Top Right */}
          {sessionStorage.getItem("config_to_date") && (
            <div className="data-updated-label">
              Last Updated: {moment(sessionStorage.getItem("config_to_date")).format('MMM YYYY')}
            </div>
          )}
        </div>

        <div className="cards_wrapper">
          <div onClick={showModal} className="card">
            <img src={car} alt="Card Background" loading="lazy" />
            <div className="overlay">
              <div style={{ width: "100%" }} className="card_title_wrapper">
                <div className="card_title">Instant Report</div>
                <div className="arrow">
                  <ArrowRightOutlined />
                </div>
              </div>
            </div>
          </div>

          <div
            onClick={() => navigate(`/${APP_PREFIX_PATH}/valuations`)}
            className="card"
          >
            <img src={car2} alt="Card Background" loading="lazy" />
            <div className="overlay">
              <div style={{ width: "100%" }} className="card_title_wrapper">
                <div className="card_title">Valuation Directory</div>
                <div className="arrow">
                  <ArrowRightOutlined />
                </div>
              </div>
            </div>
          </div>

          <div
            onClick={() =>
              navigate(`/${APP_PREFIX_PATH}/Portfolio/PortfolioDirectory`)
            }
            // onClick={warningModal}
            className="card"
          >
            <img
              src={portfolioDirectory}
              alt="Card Background"
              loading="lazy"
            />
            <div className="overlay">
              <div style={{ width: "100%" }} className="card_title_wrapper">
                <div className="card_title">Portfolio Directory</div>
                <div className="arrow">
                  <ArrowRightOutlined />
                </div>
              </div>
            </div>
          </div>
          <div
            onClick={() =>
              navigate(`/${APP_PREFIX_PATH}/Portfolio/PortfolioBuilder`)
            }
            // onClick={warningModal}

            className="card"
          >
            <img src={portfolioBuilder} alt="Card Background" loading="lazy" />
            <div className="overlay">
              <div style={{ width: "100%" }} className="card_title_wrapper">
                <div className="card_title">Portfolio Builder</div>
                <div className="arrow">
                  <ArrowRightOutlined />
                </div>
              </div>
            </div>
          </div>
          <div
            // onClick={() => navigate()}
            onClick={warningModal}
            className="card"
          >
            <img src={groups} alt="Card Background" loading="lazy" />
            <div className="overlay">
              <div style={{ width: "100%" }} className="card_title_wrapper">
                <div className="card_title">Groups</div>
                <div className="arrow">
                  <ArrowRightOutlined />
                </div>
              </div>
            </div>
          </div>

          <div
            // onClick={showAIModal}
            onClick={openAIAnalytics}
            className="card"
          >
            <img src={dealers} alt="Card Background" loading="lazy" />
            <div className="overlay">
              <div style={{ width: "100%" }} className="card_title_wrapper">
                <div className="card_title">AI & Analytics</div>
                <div className="arrow">
                  <ArrowRightOutlined />
                </div>
              </div>
            </div>
          </div>

        </div>

        <div className="dave_logo">
          <img src={dave} alt="dave-cantin-group" loading="lazy" />
        </div>
        <InstantReportModal
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          dealerData={dealerData}
          selectedDealerId={selectedDealerId}
          newValuationName={newValuationName}
          setNewValuationName={setNewValuationName}
          warning={warning}
          setWarning={setWarning}
          loading={loading}
          setSelectedDealerId={setSelectedDealerId}
          setIsModalOpen={setIsModalOpen}
          showOverlay={showOverlay}
        />

        <ReleaseNotesModal
          isOpen={isReleaseNotesModalOpen}
          onClose={handleReleaseNotesClose}
          onNext={handleReleaseNotesNext}
          loading={releaseNotesLoading}
          releaseNotesData={releaseNotesData}
        />

        {/* <AIAnalyticsModal 
        isModalOpen={isAIModalOpen}
        handleCancel={() => setIsAIModalOpen(false)}
      /> */}
      </div>
    </>
  );
};

export default LandingPage;
